module.exports = __webpack_public_path__ + "static/media/lukaaaa.568c642f.jpg";